import axios from "axios";
const API = axios.create({ baseURL: "https://kivacaree-dl71.vercel.app/" });
API.interceptors.request.use((req) => {
    console.log(req); 
  return req;
});
export const adoptionForm = (adoption) => API.post("forms/adoption", adoption);
export const donateForm = (donate) => API.post("forms/donate", donate); 
export const volunteerForm = (volunteer) => API.post("forms/volunteer", volunteer);